import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'
//POTREBBE ESSERE DUPLICATA, E' PRESENTE ANCHE ACTION/FILTERSICON
const FilterIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" alignSelf="center" {...props}>
            <path d="M16 9H18V6.43433H22V4.43433H18V2H16V9Z" fill="currentColor" />
            <path d="M2.00122 6.43433V4.43433H14V6.43433H2.00122Z" fill="currentColor" />
            <path d="M22 13.4343V11.4343H10.0012V13.4343H22Z" fill="currentColor" />
            <path d="M8 16H6V13.4343H2V11.4343H6V9H8V16Z" fill="currentColor" />
            <path d="M2.00122 18.4343V20.4343H14V18.4343H2.00122Z" fill="currentColor" />
            <path d="M16 16H18V18.4343H22V20.4343H18V23H16V16Z" fill="currentColor" />
        </Icon>
    )
}

FilterIcon.propTypes = {
    color: PropTypes.string,
}

export default FilterIcon
